import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
const InputOTPMainWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.container);
}}
`;
InputOTPMainWrapperStyled.displayName = 'InputOTPMainWrapperStyled';
const InputBasicWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.input);
}}
`;
InputBasicWrapperStyled.displayName = 'InputBasicWrapperStyled';
const ButtonWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.button);
}}
`;
ButtonWrapperStyled.displayName = 'ButtonWrapperStyled';
const LabelContainerWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.labelContainer);
}}
`;
LabelContainerWrapperStyled.displayName = 'LabelContainerWrapperStyled';
const LeftLabelWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.leftLabel);
}}
`;
LeftLabelWrapperStyled.displayName = 'LeftLabelWrapperStyled';
const RightLabelWrapperStyled = styled.section `
  ${({ styles }) => {
    return getStyles(styles?.rightLabel);
}}
`;
RightLabelWrapperStyled.displayName = 'RightLabelWrapperStyled';
export { InputOTPMainWrapperStyled, InputBasicWrapperStyled, ButtonWrapperStyled, LabelContainerWrapperStyled, LeftLabelWrapperStyled, RightLabelWrapperStyled, };
//# sourceMappingURL=input-otp.component.styled.js.map